import { useState, useEffect } from "react";

/* One-shot typewriter — types once, caret keeps blinking. */
export default function Typewriter({
  text,
  className = "",
  speed = 60,
  startDelay = 400,
}) {
  const [n, setN] = useState(0);

  useEffect(() => {
    if (n >= text.length) return;
    if (
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setN(text.length);
      return;
    }
    const t = setTimeout(
      () => setN((v) => Math.min(v + 1, text.length)),
      n === 0 ? startDelay : speed
    );
    return () => clearTimeout(t);
  }, [n, text, speed, startDelay]);

  return (
    <span className={className} aria-label={text}>
      <span aria-hidden="true">{text.slice(0, n)}</span>
      <span className="tw-caret" aria-hidden="true" />
    </span>
  );
}
